import { render, staticRenderFns } from "./InputLbaSelect.vue?vue&type=template&id=b58dbf0a"
import script from "./InputLbaSelect.vue?vue&type=script&lang=js"
export * from "./InputLbaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports